<template>
  <div class="overall">
    <div class="first layer">
      <div class="card">
        <div class="statistic-card">
          <p class="title">总用户数</p>
          <p class="value">168 <span class="change increase">+2</span></p>
          <p class="tip">使用客户端的用户数量</p>
        </div>
        <div class="statistic-card">
          <p class="title">总船舶数</p>
          <p class="value">2158 <span class="change increase">+5</span></p>
          <p class="tip">绑定云端的船舶数量</p>
        </div>
        <div class="statistic-card">
          <p class="title">今日总里程数</p>
          <p class="value">
            412,306 km <span class="change decrease">-3%</span>
          </p>
          <p class="tip">今日所有绑定云端船舶的总里程数</p>
        </div>
        <div class="statistic-card">
          <p class="title">今日总减排</p>
          <p class="value">
            15,302 m³ <span class="change increase">+11%</span>
          </p>
          <p class="tip">今日通过新能源船舶减排的二氧化碳</p>
        </div>
      </div>
    </div>
    <div class="second layer">
      <div class="card left">
        <v-chart class="chart" :option="option"></v-chart>
      </div>
      <div class="card right"></div>
    </div>
    <div class="third layer">
      <div class="card left"></div>
      <div class="card right"></div>
    </div>
    <div style="margin-top: 20px"></div>
  </div>
</template>
<script lang="ts" setup>
import VChart from "vue-echarts";
import { use } from "echarts/core";
import { LineChart } from "echarts/charts";
import {
  TitleComponent,
  GridComponent,
  TooltipComponent,
} from "echarts/components";
import { CanvasRenderer } from "echarts/renderers";
import { onMounted, ref } from "vue";

use([
  TitleComponent,
  GridComponent,
  TooltipComponent,
  LineChart,
  CanvasRenderer,
]);

// 模拟数据
const timeData = ref<string[]>([]);
const userData = ref<number[]>([]);
const getRandomArray = (init: number, range: number) => {
  const arr = [] as number[];
  arr.unshift(init);

  for (let i = 1; i < 30; i++) {
    const lastValue = arr[0]; // 获取最新的值
    const min = Math.max(0, lastValue - range); // 限制最小值，防止小于 0
    const max = Math.min(1000, lastValue + range); // 限制最大值，防止超过 1000
    const newValue = Math.floor(Math.random() * (max - min + 1)) + min; // 生成符合范围的随机数
    arr.unshift(newValue);
  }
  return arr;
};

const generateData = () => {
  for (let i = 1; i < 30; i++) {
    timeData.value.unshift(
      new Date(Date.now() - 1000 * 60 * 60 * 24 * i).toLocaleString()
    );
  }
  userData.value.splice(0, userData.value.length, ...getRandomArray(156, 5));
};

const option = ref({
  title: {
    text: "用户数",
    left: "1%",
  },
  xAxis: {
    data: timeData.value,
  },
  tooltip: {
    trigger: "axis",
  },
  yAxis: {
    type: "value",
  },
  series: [
    {
      data: userData.value,
      type: "line",
    },
  ],
});

onMounted(() => {
  generateData();
});
</script>
<style lang="less" scoped>
.overall {
  width: 100%;
  height: 100%;
  padding: 7px;
}
.layer {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 7px;
  & > .card {
    box-shadow: 0 0 10px 1px rgb(218, 218, 218);
    background-color: #ffffff;
    border-radius: 20px;
    overflow: hidden;
    display: flex;
  }
}
.first {
  height: 20%;
  & > .card {
    width: 100%;
    height: 100%;
    & > .statistic-card {
      width: 25%;
      height: 100%;
      border-right: 1px solid #e2e2e2;
      padding: 20px;
      transition: all 0.2s;
      &:hover {
        background-color: #fde6ff;
      }
      & > .title {
        font-size: 20px;
        font-family: "SimHei";
      }
      & > .value {
        font-size: 42px;
        margin: 10px 0;
        font-family: "Times New Roman";
        font-weight: bolder;
        & > .change {
          font-family: "Arial";
          font-size: 16px;
        }
        & > .increase {
          color: #ff0000;
        }
        & > .decrease {
          color: #00b200;
        }
      }
      & > .tip {
        font-size: 12px;
        color: rgb(92, 92, 92);
      }
    }
  }
}
.second {
  height: 45%;
  & > .left {
    width: 74%;
    height: 100%;
    & > .chart {
      width: 100%;
      height: 100%;
    }
  }
  & > .right {
    width: 25%;
    height: 100%;
  }
}
.third {
  height: 30%;
  & > .left {
    width: 74%;
  }
  & > .right {
    width: 25%;
  }
}
</style>
